import React from "react";
import { gql } from "apollo-boost";

import SettingsList from "superAdminViews/setting/SettingsList";

const ADD = gql`
  mutation createDriverReadyCommentByAdmin($type: String!) {
    createDriverReadyCommentByAdmin(input: { type: $type }) {
      _id
      type
    }
  }
`;

const GET = gql`
  query getDriverReadyCommentsByAdmin($limit: Int, $skip: Int) {
    getDriverReadyCommentsByAdmin(pagination: { limit: $limit, skip: $skip }) {
      _id
      type
    }
  }
`;

const COUNT = gql`
  query getDriverReadyCommentsByAdminCount {
    getDriverReadyCommentsByAdminCount
  }
`;

const UPDATE = gql`
  mutation updateDriverReadyCommentByAdmin($id: ID!, $type: String!) {
    updateDriverReadyCommentByAdmin(id: $id, input: { type: $type }) {
      _id
      type
    }
  }
`;

const DELETE = gql`
  mutation removeDriverReadyCommentByAdmin($idSet: [ID!]!) {
    removeDriverReadyCommentByAdmin(idSet: $idSet) {
      _id
    }
  }
`;

const FIELDS = [
  {
    name: "type",
    label: "Comment",
    type: "text",
    required: true,
    hint: "Keep it short — it appears as a tappable chip in the app.",
  },
];

/**
 * DriverReadyComments - the canned remarks a passenger taps to
 * describe their driver at the end of a trip.
 */
const DriverReadyComments = () => (
  <SettingsList
    title="Driver ready comments"
    description="What a passenger can tap to describe their driver after a trip."
    singular="comment"
    list={{ query: GET, key: "getDriverReadyCommentsByAdmin" }}
    count={{ query: COUNT, key: "getDriverReadyCommentsByAdminCount" }}
    create={{ mutation: ADD, variables: (values) => ({ type: values.type.trim() }) }}
    update={{
      mutation: UPDATE,
      variables: (values, row) => ({ id: row._id, type: values.type.trim() }),
    }}
    remove={{ mutation: DELETE }}
    columns={[{ key: "type", label: "Comment", width: "3fr" }]}
    fields={FIELDS}
    toValues={(row) => ({ type: row.type })}
  />
);

export default DriverReadyComments;
